import React from 'react';
import Layout from '@/components/Layout';

const ShippingReturnsPage = () => {
  return (
    <Layout>
      <div style={{ background: 'var(--color-background)' }} className="section-padding">
        <div className="container-custom max-w-4xl">
          <h1 className="text-5xl font-bold mb-8" style={{ color: 'var(--color-text-primary)' }}>
            Shipping & Returns Policy
          </h1>
          <p className="mb-6" style={{ color: 'var(--color-text-secondary)' }}>
            Last updated: January 2026
          </p>

          <div className="space-y-8" style={{ color: 'var(--color-text-secondary)' }}>
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>
                Shipping Information
              </h2>
              
              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--color-accent)' }}>
                Delivery Times
              </h3>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li><strong>Nairobi:</strong> Same-day or next-day delivery</li>
                <li><strong>Major Cities:</strong> 1-3 business days</li>
                <li><strong>Remote Areas:</strong> 3-5 business days</li>
              </ul>

              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--color-accent)' }}>
                Shipping Costs
              </h3>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Free shipping on orders above KSh 50,000 within major cities</li>
                <li>Standard shipping: KSh 500 - 1,500 depending on location and weight</li>
                <li>Express shipping available at additional cost</li>
              </ul>

              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--color-accent)' }}>
                Store Pickup
              </h3>
              <p className="mb-4">
                Free pickup available at our stores in Nairobi, Meru Town, and Mombasa. Select "Store Pickup" during checkout and we'll notify you when your order is ready (usually within 2-4 hours).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>
                Returns Policy
              </h2>
              
              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--color-accent)' }}>
                Return Window
              </h3>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li><strong>New Products:</strong> 14 days from delivery date</li>
                <li><strong>Refurbished Products:</strong> 7 days from delivery date</li>
              </ul>

              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--color-accent)' }}>
                Return Conditions
              </h3>
              <p className="mb-4">
                To be eligible for a return, items must:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Be unused and in original condition</li>
                <li>Include all original packaging, accessories, and documentation</li>
                <li>Have all protective films and seals intact</li>
                <li>Not show signs of use, wear, or damage</li>
              </ul>

              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--color-accent)' }}>
                How to Return
              </h3>
              <ol className="list-decimal pl-6 space-y-2 mb-6">
                <li>Contact us at aethernexus05@gmail.com or +254 703 207 300</li>
                <li>Provide your order number and reason for return</li>
                <li>Receive return authorization and instructions</li>
                <li>Pack the item securely in original packaging</li>
                <li>Ship to our return address or drop off at any store</li>
              </ol>

              <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--color-accent)' }}>
                Refunds
              </h3>
              <p className="mb-4">
                Once we receive and inspect your return:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Approved returns are refunded within 5-7 business days</li>
                <li>Refunds are issued to the original payment method</li>
                <li>M-Pesa refunds are processed within 24 hours</li>
                <li>Card refunds may take 7-14 days depending on your bank</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>
                Exchanges
              </h2>
              <p className="mb-4">
                We offer exchanges for defective or damaged items. If you receive a defective product:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Contact us within 48 hours of delivery</li>
                <li>Provide photos of the defect or damage</li>
                <li>We'll arrange a replacement at no additional cost</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>
                Non-Returnable Items
              </h2>
              <p className="mb-4">
                The following items cannot be returned:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Products with broken seals or missing parts</li>
                <li>Software with opened license keys</li>
                <li>Custom-configured or personalized items</li>
                <li>Items purchased on clearance or special sale (unless defective)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>
                Contact Us
              </h2>
              <p>
                For shipping or return inquiries:
                <br />
                Email: aethernexus05@gmail.com
                <br />
                Phone: +254 703 207 300
                <br />
                Business Hours: Mon-Sat 8:00 AM - 7:00 PM, Sun 10:00 AM - 5:00 PM
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ShippingReturnsPage;
